export const getBrandDomain = () => {
  const host = location.hostname;

  if (host.match(/xbo(.|-)eu/gm)) return 'xbo.eu';

  return 'xbo.com';
};
